<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import BotForm from '@components/bot-form'
import BotInboundPhone from '@components/bot-inbound-phone'

export default {

    page: {
		title: 'Мои боты',
		meta: [{ name: 'description', content: appConfig.description }],
	},

    components: { Layout, PageHeader, BotForm, BotInboundPhone },

	data() {
		return {
			title: 'Мои боты',
			items: [],
            tableData: [],
            currentPage: 1,
            perPage: 12,
            pageOptions: [12, 24, 60, 120],
            filter: null,
            filterOn: null,
            sortBy: 'id',
            sortDesc: false,
            fields: [                
                { key: 'select',   label: '', row:{'rowSelected':false}},
                { key: 'id', label: 'ID', sortable: true },
                { key: 'name', label: 'Имя', sortable: true },
                { key: 'fl_enabled', label: 'Бот', sortable: false },
                { key: 'description', label: 'Описание', sortable: true },
                { key: 'user_data', label: 'Пользователь', sortable: false },
                { key: 'updated_at', label: 'Обновлен', sortable: true },
                { key: 'action', label: ''}
            ],
            tableLoading: true,
            watch: false,
            formBotPopup: {
                visible: false,
                uuid: null,
                action: null
            },
            phonePopup: {
                visible: false,
                uuid: null
            },
            view_type: 'list'
		}
	},

    computed: {
        total_rows() {
            return this.$store.getters['bots/GET_BOTS_TOTAL_ROWS'];
        },
        table_data() {
            this.tableLoading = false;
            return this.$store.getters['bots/GET_BOTS_TABLE_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
        session_item(){
            return this.$store.getters['sessions/GET_SESSIONS_ITEM'];
        }
    },

    watch: {
        sortBy: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onSorted();
                }
            }
        },
        sortDesc: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onSorted();
                }
            }
        },
        perPage: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onChangePerPage();
                }
            }
        },
        currentPage: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onChangeCurrentPage();
                }
            }
        },
    },

    async mounted() {
        
        if(this.session_user_item && this.session_user_item.role === 'administrator' || this.session_user_item.type === 'dev'){
            this.fields = [                
                { key: 'select',   label: '', row:{'rowSelected':false}},
                { key: 'id', label: 'ID', sortable: true },
                { key: 'name', label: 'Имя', sortable: true },
                { key: 'fl_enabled', label: 'Бот', sortable: false },
                { key: 'description', label: 'Описание', sortable: true },
                { key: 'user_data', label: 'Пользователь', sortable: false },
                { key: 'dev_data', label: 'Разработчик', sortable: true },
                { key: 'updated_at', label: 'Обновлен', sortable: true },
                { key: 'action', label: ''}
            ]
        }

        await this.getData();
    },

    methods: {
        async onFiltered() {
            this.currentPage = 1;
            await this.getData();
        },
        async onSorted(){
            await this.getData();
        },
        async onChangePerPage(){
            this.currentPage = 1;
            await this.getData();
        },
        async onChangeCurrentPage(){
            await this.getData();
        },
        async getData(){
            this.tableLoading = true;
            let data_send = {
                'limit'    : this.perPage,
                'page'     : this.currentPage,
                'sortBy'   : this.sortBy,
                'sortDesc' : this.sortDesc === false ? 'ASC' : 'DESC',
                'filter'   : this.filter,
                'filterOn' : JSON.stringify(this.filterOn)
            }
            await this.$store.dispatch('bots/FETCH_BOTS_LIST', data_send);
            this.watch = true;
        },
        async toggleEnabled(item, value){
            const enabled = value === true
            if(!enabled && !window.confirm('Выключить бота «' + item.name + '»?\n\nОн перестанет звонить и принимать входящие звонки, пока вы снова его не включите.')){
                this.$set(item, 'fl_enabled', true)
                return
            }
            this.$set(item, 'enabled_saving', true)
            const res = await this.$store.dispatch('bots/FETCH_BOTS_SET_ENABLED', {uuid: item.uuid, enabled: enabled})
            this.$set(item, 'enabled_saving', false)
            if(res === false){
                window.alert('Не удалось переключить бота. Обновите страницу и попробуйте ещё раз.')
                await this.getData()
                return
            }
            this.$set(item, 'fl_enabled', res.fl_enabled === true)
        },
        async delItem(uuid){
            await this.$store.dispatch('bots/FETCH_BOTS_DELETE', {uuid: uuid});
            await this.getData();
            return false;
        },
        openFormBotPopup(action, uuid = '') {
          this.formBotPopup.visible = true
          this.formBotPopup.action = action
          this.formBotPopup.uuid = uuid

        },

        openPhonePopup(uuid) {
          this.phonePopup.uuid = uuid
          this.phonePopup.visible = true
        },

        closeFormBotPopup() {
          this.formBotPopup.visible = false
          this.getData()
        }
    },
}
</script>

<template>
	<Layout>
        <b-modal
            v-model="formBotPopup.visible"
            centered
            size="lg"
            :title="'Редактировать бота'"
            title-class="font-18"
            hide-footer
        >
            <bot-form v-if="formBotPopup.visible" :action="formBotPopup.action" :uuid="formBotPopup.uuid" @close="closeFormBotPopup"/>
        </b-modal>

        <b-modal
            v-model="phonePopup.visible"
            centered
            size="lg"
            title="Входящий номер боту"
            title-class="font-18"
            hide-footer
        >
            <bot-inbound-phone v-if="phonePopup.visible" :uuid="phonePopup.uuid" @close="phonePopup.visible = false"/>
        </b-modal>

        <div class="row page-title align-items-center">
            <div class="col-sm-8 col-xl-6">
                <h4 class="mb-1 mt-0"><i class="feather uil uil-robot"></i>{{ title }}</h4>
            </div>
            <div class="col-sm-4 col-xl-6">
                <form class="form-inline float-sm-right mt-3 mt-sm-0">
                    <div class="btn-group">
                        <a class="btn btn-primary" @click="openFormBotPopup('create')">
                            <i class="uil uil-plus " style="margin-right: 5px"></i>Создать бота
                        </a>
                    </div>
                </form>
            </div>
        </div>

        <div class="row">
            <div class="col-12">

                <div class="row" style="margin-top: 20px; margin-bottom: 5px">
                    <div class="col-sm-6 col-md-6">
                        <div id="tickets-table_length" class="dataTables_length">
                            <label class="d-inline-flex align-items-center">
                                Показывать&nbsp;
                                <b-form-select
                                    v-model="perPage"
                                    size="md"
                                    :options="pageOptions"
                                ></b-form-select
                                >&nbsp;записей
                            </label>
                        </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-6 col-md-6">
                        <div
                            id="tickets-table_filter"
                            class="dataTables_filter text-md-right"
                        >
                            <label class="d-inline-flex align-items-center">
                                Поиск:
                                <b-form-input
                                    v-model="filter"
                                    type="search"
                                    @change="onFiltered()"
                                    placeholder="Введите текст..."
                                    class="form-control form-control-md ml-2"
                                ></b-form-input>
                            </label>
                            <div class="btn-group ml-2 mr-2">
                                <button type="button" :class="view_type === 'list' ? 'btn btn-primary' : 'btn btn-white'" @click="view_type='list'"><i class="feather uil uil-align-justify"></i></button>
                                <button type="button" :class="view_type === 'table' ? 'btn btn-primary' : 'btn btn-white'" @click="view_type='table'"><i class="feather uil uil-apps"></i></button>
                            </div>

                        </div>
                    </div>
                    <!-- End search -->
                </div>         

                <div v-if="view_type === 'table'" class="row">
                    <div v-for="(row, index) in table_data" class="col-md-3 col-xl-3">
                        <div class="card">
                            <div class="card-body pb-0">
                                <b-dropdown
                                    variant="link"
                                    class="float-right"
                                    right
                                    toggle-class="p-0 text-muted arrow-none"
                                >
                                    <template v-slot:button-content>
                                        <i class="uil uil-ellipsis-v font-size-14"></i>
                                    </template>
                                    <b-dropdown-item v-if="row.version === '2'" @click="openFormBotPopup('edite', row.uuid)" href="javascript: void(0);"
                                        ><i class="uil uil-edit-alt mr-2"></i>Редактировать</b-dropdown-item
                                    >
                                    <b-dropdown-item v-if="row.version === '2'" :to="{ name: 'Mindmap.edit', params: { type: 'bot', uuid: row.uuid } }"
                                        ><i class="uil uil-sitemap mr-2"></i>Редактор сценария</b-dropdown-item
                                    >
                                    <b-dropdown-item v-if="session_user_item && session_user_item.role === 'administrator'" :to="{ name: 'Bots.dialogCache', params: { uuid: row.uuid } }"
                                        ><i class="uil uil-comment-alt-lines mr-2"></i>Диалоговый кэш</b-dropdown-item
                                    >
                                    <b-dropdown-item v-if="session_user_item && session_user_item.role === 'administrator'" @click="openPhonePopup(row.uuid)" href="javascript: void(0);"
                                        ><i class="uil uil-phone mr-2"></i>Присвоить номер</b-dropdown-item
                                    >
                                    <b-dropdown-item v-if="row.version === '1'" :to="{ name: 'Bots.edit', params: { bot_uuid: row.uuid }}"
                                        ><i class="uil uil-edit-alt mr-2"></i>Редактировать</b-dropdown-item
                                    >
                                    <b-dropdown-item href="javascript: void(0);" @click.native="delItem(row.item.uuid)" variant="danger">
                                        <i class="uil uil-trash mr-2"></i>Удалить
                                    </b-dropdown-item>
                                </b-dropdown>                                  
                                <div class="text-center mt-3">                                                                       
                                    <img
                                        src="@assets/images/users/avatar-7.jpg"
                                        alt
                                        class="avatar-xl rounded-circle"
                                    />
                                    <h5 class="mt-2 mb-0">{{row.name}}</h5>
                                    <div class="mt-2 d-flex justify-content-center">
                                        <b-form-checkbox v-model="row.fl_enabled" switch :disabled="row.enabled_saving" @change="toggleEnabled(row, $event)">
                                            {{ row.fl_enabled ? 'Бот включён' : 'Бот выключен' }}
                                        </b-form-checkbox>
                                    </div>
                                    <h6 class="text-muted font-weight-normal mt-2 mb-4">
                                        Ассистент менеджера по продажам                                        
                                    </h6>
                                    <div class="mt-4 pt-3 border-top text-left">
                                        <p class="text-muted mb-2">{{row.description ? row.description : 'Описание отсутствует'}}</p>
                                    </div>
                                    <div class="mt-4 pt-3 border-top text-left">
                                        <p v-if="session_user_item.type !== 'client'" class="text-muted mb-2">Разработчик:<br><i class="uil uil-user mr-2"></i><span class="font-weight-bold">{{row.dev_data}}</span></p>
                                        <p v-if="session_user_item.type !== 'client'" class="text-muted mb-2">Пользователь:<br><i class="uil uil-user mr-2"></i><span class="font-weight-bold">{{row.user_data}}</span></p>
                                        <p class="text-muted mb-2">Последнее обновление:<br><i class="uil uil-calendar-alt mr-2"></i><span class="font-weight-bold">{{ row.updated_at }}</span></p>                                        
                                        <p class="mb-2">
                                            <label class="badge badge-soft-success">Продажа услуг</label>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="view_type === 'list'" class="card">
                    <div class="card-body" style="padding-left: 0px; padding-right: 0px;">

                        <div class="table-responsive mb-0">
                            <b-table
                                :items="table_data"
                                :fields="fields"
                                responsive="sm"
                                current-page="1"
                                :class = "tableLoading ? 'loading' : ''"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :no-local-sorting="true"
                            >
                                <template #cell(fl_enabled)="row">
                                    <b-form-checkbox v-model="row.item.fl_enabled" switch :disabled="row.item.enabled_saving" @change="toggleEnabled(row.item, $event)">
                                        {{ row.item.fl_enabled ? 'Включён' : 'Выключен' }}
                                    </b-form-checkbox>
                                </template>
                                <template #cell(action)="row">
                                    <div style="text-align: right;">
                                        <b-dropdown
                                            variant="link"
                                            class="float-right"
                                            right
                                            toggle-class="p-0 text-muted arrow-none"
                                        >
                                            <template v-slot:button-content>
                                                <i class="uil uil-ellipsis-v font-size-14"></i>
                                            </template>
                                            <b-dropdown-item v-if="row.item.version === '2'" @click="openFormBotPopup('edite', row.item.uuid)" href="javascript: void(0);"
                                                ><i class="uil uil-edit-alt mr-2"></i>Редактировать</b-dropdown-item
                                            >
                                            <b-dropdown-item v-if="row.item.version === '2'" :to="{ name: 'Mindmap.edit', params: { type: 'bot', uuid: row.item.uuid } }"
                                                ><i class="uil uil-sitemap mr-2"></i>Редактор сценария</b-dropdown-item
                                            >
                                            <b-dropdown-item v-if="session_user_item && session_user_item.role === 'administrator'" :to="{ name: 'Bots.dialogCache', params: { uuid: row.item.uuid } }"
                                                ><i class="uil uil-comment-alt-lines mr-2"></i>Диалоговый кэш</b-dropdown-item
                                            >
                                            <b-dropdown-item v-if="session_user_item && session_user_item.role === 'administrator'" @click="openPhonePopup(row.item.uuid)" href="javascript: void(0);"
                                                ><i class="uil uil-phone mr-2"></i>Присвоить номер</b-dropdown-item
                                            >
                                            <b-dropdown-item v-if="row.item.version === '1'" :to="{ name: 'Bots.edit', params: { bot_uuid: row.item.uuid, copy: true }}"
                                                ><i class="uil uil-edit-alt mr-2"></i>Редактировать</b-dropdown-item
                                            >
                                            <b-dropdown-item href="javascript: void(0);" @click.native="delItem(row.item.uuid)" variant="danger">
                                                <i class="uil uil-trash mr-2"></i>Удалить
                                            </b-dropdown-item>
                                        </b-dropdown> 
                                    </div>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>


                <div class="row" style="margin-bottom: 30px">
                    <div class="col">
                        <div
                            class="dataTables_paginate paging_simple_numbers float-left"
                        >
                            <ul class="pagination pagination-rounded mb-0">
                                <!-- pagination -->
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="total_rows"
                                    :per-page="perPage"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </div>
	</Layout>
</template>

<style>
.table-responsive-sm{
    transition: all .5s;
}
.table-responsive-sm.loading{
    opacity: 0.3;
}
</style>